import Vue from 'vue'
import Router from 'vue-router'
import headers from '../components/headers'
import footer from '../components/footer'
import banner from '../components/banner'
import value from '../components/value'
import culture from '../components/culture'
import registerbackground from '../components/registerbackground'
import loginbackground from '../components/loginbackground.vue'
import job from '../components/job'
import about from '../components/about'
import price from '../components/price'
import moments from '../components/moments'
import friend from '../components/friend'
import mycenter from '../components/mycenter'
import judge from '../components/judge'
import companyverify from '../components/companyverify'
import nameverify from '../components/nameverify'
import notice from '../components/notice'
import kefu from '../components/kefu'
import jobintro from '../components/jobintro'
import useragreement from '../components/useragreement'
import privateagree from '../components/privateagree'
import VueRouter from 'vue-router'



Vue.use(Router)

export default new Router({

  //  mode: 'history',
  linkActiveClass: 'is-active',

  routes: [{
    path: '/',
    components: {
      headers: headers,
      banner: banner,
      value: value,
      culture: culture,
      footer: footer
    },
    meta: {
      //需要登录后才能访问
      requiresAuth: true
    },

    beforeEnter(to, from, next) {
      [].forEach.call(document.getElementsByTagName('li'), function (item) { item.className = '' });
      next();
    }
  }, {
    path: '/login',
    name: "login",
    components: {
      loginbackground: loginbackground
    }

  }, {
    path: '/reg',
    name: "register",
    components: {
      registerbackground: registerbackground
    }
  },
  {
    path: '/job',
    name: "job",
    components: {
      job: job
    }
  },
  {
    path: '/about',
    name: "about",
    components: {
      about: about
    }
  },
  {
    path: '/price',
    name: "price",
    components: {
      price: price
    }
  },
  {
    path: '/moments',
    name: "moments",
    components: {
      moments: moments
    }
  },
  {
    path: '/friend',
    name: "friend",
    components: {
      friend: friend
    }
  },
  {
    path: '/mycenter',
    name: "mycenter",
    components: {
      mycenter: mycenter
    }
  },
  {
    path: '/judge',
    name: "judge",
    components: {
      judge: judge
    }
  },
  {
    path: '/companyverify',
    name: "companyverify",
    components: {
      companyverify: companyverify
    },

  },
  {
    path: '/nameverify',
    name: "nameverify",
    components: {
      nameverify: nameverify
    },

  },
  {
    path: '/notice',
    name: "notice",
    components: {
      notice: notice
    }
  },
  {
    path: '/kefu',
    name: "kefu",
    components: {
      kefu: kefu
    }
  },
  {
    path: '/jobintro',
    name: "jobintro",
    components: {
      jobintro: jobintro
    }
  },
  {
    path: '/useragreement',
    name: "useragreement",
    components: {
      useragreement: useragreement
    }
  },
  {
    path: '/privateagree',
    name: "privateagree",
    components: {
      privateagree: privateagree
    }
  },
  ],
  scrollBehavior(to, from, savedPosition) {
    console.log(to, from, savedPosition);
    return { x: 0, y: 0 };
  },






})
let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;
//重写push/replace
//第一个参数：告诉原来的push方法，往哪里跳转（传递哪些参数）
//第二个参数：成功的回调
//第三个参数：失败的回调
//call/apply区别
//相同点：都可以调用函数一次，都可以篡改函数的上下文(this）一次‘
//不同点：call/apply传递参数：call传递参数用逗号隔开，apply方法执行，传递数组
VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject);
  } else {
    originPush.call(this, location, () => { }, () => { });
  }
}
VueRouter.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject);
  } else {
    originReplace.call(this, location, () => { }, () => { });
  }
}


// WEBPACK FOOTER //
// ./src/router/index.js